import axios from '../axios';

// 银行卡列表
export const getBaseEmployeeBankPage = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeBankPage',
        method: 'post',
        data
    })
};

// 银行卡保存
export const saveBaseEmployeeBank = data => {
    return axios({
        url: '/api/sys/base/saveBaseEmployeeBank',
        method: 'post',
        data
    })
};

// 银行卡修改
export const updateBaseEmployeeBank = data => {
    return axios({
        url: '/api/sys/base/updateBaseEmployeeBank',
        method: 'post',
        data
    })
};

// 银行卡删除
export const deleteBaseEmployeeBanks = data => {
    return axios({
        url: '/api/sys/base/deleteBaseEmployeeBanks',
        method: 'post',
        data
    })
};

// 银行卡查单条
export const getBaseEmployeeBank = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeBank',
        method: 'post',
        data
    })
};




// WEBPACK FOOTER //
// ./src/api/moudules/bankCard.js